// Gateway base: "" in production (same origin on atlas.brightcma.com), a workers.dev URL for
// preview builds, "/gw" for the fixture build used by e2e and Lighthouse.
export const GATEWAY: string = (import.meta.env.VITE_GATEWAY ?? "").replace(/\/$/, "");

// [west, south, east, north], same as the gateway (atlas-search spec).
export const METRO_BBOX = [-98.2, 29.98, -97.15, 30.92] as const;

export interface View {
  lng: number;
  lat: number;
  zoom: number;
  pitch: number;
  bearing: number;
}

// Owner decision G7: tilted downtown and Lady Bird Lake, buildings and both floodplains on.
// Zoom stays at or above the extrusion minzoom (15) so the buildings show.
export const HERO_VIEW: View = { lng: -97.7469, lat: 30.2622, zoom: 15.3, pitch: 60, bearing: -24 };
export const HERO_LAYERS = ["fema-nfhl", "coa-floodplain-atlas14", "txgio-footprints"];
export const DRIFT_DEGREES = 30;
export const DRIFT_MS = 10_000;
export const PITCH_3D = 50;
